import { PORTAL_TRACKER_KEY_MAP } from './modules/index'

// 公共参数
const TRACKER_KEY = 'new_portal'

// 公共埋点方法
const tracker = (keyName: string, params: any = {}) => {
  const commonTrackParams = {
    currentTime: new Date().getTime()
  }
  try {
    // 未传keyName 或 无此埋点 则中断埋点
    if (!keyName || !PORTAL_TRACKER_KEY_MAP[keyName]) return
    const { key = '', label = '' } = PORTAL_TRACKER_KEY_MAP[keyName]
    console.log('portal_tracker', key, label, params)
    window.log(TRACKER_KEY, key, JSON.stringify({ label, ...commonTrackParams, ...params }))
  } catch (error) {
    console.log('TRACKER_ERROR', error)
  }
}

export default tracker
